import 'jquery-validation';

export default {
    init() {
        console.log('ACCOUNT');

        // if exist - correct link do PDF invoice
        if ($('#invoice-pdf').length) {
          console.log('fix invoice url');
          $('#invoice-pdf').attr('href', $('#invoice-pdf').attr('href') + '&integration_id=integration-wooifirma');
        }

        $('form[name="login"]').validate({
            rules: {
                username: {
                    required: true,
                },
                password: {
                    required: true,
                },
            },
            messages: {
                username: '<span class="pl">Wpisz poprawny adres email</span><span class="en">Please enter a valid email address</span>',
                password: {
                    required: '<span class="pl">Wpisz swoje hasło</span><span class="en">Enter your password</span>',
                },
            },
            errorPlacement: function ($error, $element) {
                const name = $element.attr('name');
                console.log(name);
                $('#error-' + name + '-login').append($error);
            },
        });

        $('form[name="register"]').validate({
        rules: {
          email: {
            required: true,
            email: true,
          },
          password: {
            required: true,
            minlength: 8,
          },
          terms: {
            required: true,
          },
        },
        messages: {
          email: '<span class="pl">Wpisz poprawny adres email</span><span class="en">Please enter a valid email address</span>',
          password: {
            required: '<span class="pl">Wpisz hasło</span><span class="en">Enter your password</span>',
            minlength: '<span class="pl">Twoje hasło jest za krótkie</span><span class="en">Your password is too short</span>',
          },
          terms: '<span class="pl">Musisz zaakceptować warunki</span><span class="en">You must accept the terms and conditions and privacy policy</span>',
        },
        errorPlacement: function ($error, $element) {
          const name = $element.attr('name');
          console.log(name);
          $('#error-' + name + '-register').append($error);
        },
        });

        $('form[name="lost_password"]').validate({
            rules: {
                user_login: {
                    required: true,
                },
            },
            messages: {
                user_login: '<span class="pl">Wpisz poprawny adres email</span><span class="en">Please enter a valid email address</span>',
            },
            errorPlacement: function ($error, $element) {
                const name = $element.attr('name');
                console.log(name);
                $('#error-' + name + '-lost').append($error);
            },
        });

        $('form[name="reset-password"]').validate({
            rules: {
                password_1: {
                    required: true,
                },
                password_2: {
                    required: true,
                },
            },
            messages: {
                password_1: '<span class="pl">Wpisz nowe hasło</span><span class="en">Enter new password</span>',
                password_2: '<span class="pl">Potwierdź wpisane hasło</span><span class="en">Confirm new password</span>',
            },
            errorPlacement: function ($error, $element) {
                const name = $element.attr('name');
                console.log(name);
                $('#error-' + name).append($error);
            },
        });
    },
}



// WEBPACK FOOTER //
// ./scripts/routes/account.js